import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid2 as Grid } from '@mui/material';
import { EL_COLORS, color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { useWorkflowStore } from '@/state/workflow.state';
import { TextSmMd, TextSmRg } from '@/UI/AppTypography/AppTypography';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { FlexCenVerSpaceBetween, FlexCol } from '@/UI/styles';
import { PlusIcon } from '@/UI/Icons/PlusIcon';
import { FileIcon } from '@/UI/Icons/FileIcon';

function AppBuilderPanelTitleRow() {
  const recipeName = useWorkflowStore((state) => state.recipe.name);

  return (
    <FlexCenVerSpaceBetween
      data-testid="app-builder-title-row"
      sx={{
        px: 2,
        py: 1.5,
        gap: 1,
        minHeight: 40,
        width: '100%',
      }}
    >
      <TextSmMd component="span" color={color.White100} noWrap sx={{ flex: 1, minWidth: 0 }}>
        {recipeName}
      </TextSmMd>
      <Box sx={{ flexShrink: 0, display: 'flex', color: color.White100 }} aria-hidden>
        <FileIcon width={17} height={17} />
      </Box>
    </FlexCenVerSpaceBetween>
  );
}

export function AppBuilderPanel() {
  const { t } = useTranslation();

  return (
    <Grid size="grow" sx={{ overflowY: 'auto', display: 'flex', flexDirection: 'column' }} className="wea-no-scrollbar">
      <AppBuilderPanelTitleRow />
      <Divider sx={{ borderColor: EL_COLORS.BoxBorder }} />

      <Box sx={{ px: 2, pt: 1.5 }}>
        <TextSmMd color={color.White64_T}>{t(I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.OUTPUTS)}</TextSmMd>
      </Box>

      <FlexCol
        data-testid="app-builder-empty-state"
        sx={{
          flex: 1,
          alignItems: 'flex-start',
          px: 2,
          pt: 3,
          pb: 2,
          gap: 3,
        }}
      >
        <FlexCol sx={{ alignItems: 'flex-start', gap: 0.5 }}>
          <TextSmRg color={color.White64_T}>
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_1)}
            <br />
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_2)}
          </TextSmRg>
        </FlexCol>

        <ButtonContained
          mode="text"
          size="small"
          type="button"
          data-testid="app-builder-add-output"
          startIcon={<PlusIcon width={16} height={16} />}
        >
          {t(I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.ADD_OUTPUT)}
        </ButtonContained>
      </FlexCol>
    </Grid>
  );
}
